import { BaseTLTableComponent, AxiosResponse, tlISODateToLocalString, tlISODateTimeToLocalNoSecondsString, BaseTLTableBase } from "../../../Infrastructure/CorBase/CoreBase";
import { PricelistTemplateService, PricelistTemplateFilter } from "../../../Services/AccBase/AllAccServices";

export default abstract class PricelistTemplateListBase extends BaseTLTableComponent {

	protected pricelistTemplateService: PricelistTemplateService = new PricelistTemplateService();

	typeEnums: any[] = [];
	items: any[] = [];
	defaultEnum = '1';
	idType = '';

	callActionClick() {
		this.isBusy = true;
		this.deleteItemsList = this.getSelectedList();
		super.deleteList();
		this.itemsSelected = null;
		(this.$refs.pricelistTemplateTable as BaseTLTableBase).clearSelected();	
	}	

	protected deleteListServer(): Promise<AxiosResponse<any>> {
		return this.pricelistTemplateService.deleteList(this.deleteItemsList);
	}

	protected contentModal = this.$t('pricelistTemplate.messageQuestionMain').toString();

	deleteItem = 0;
	protected showAlertBeforeDeleteBase(itemsSelected: any) {	
		this.deleteItem = Number(itemsSelected);	
		this.showAlertBeforeActionClickBase(itemsSelected, this.$t('pricelistTemplate.messageQuestionMain').toString());		
	}

	protected setFields() {
		this.fields = [
			//{ key: 'id', label: this.$t('pricelistTemplate.fieldIdentif'), trans: 'pricelistTemplate.fieldIdentif', sortable: true, class: 'text-center' },
			//{ key: 'idItemType', label: this.$t('pricelistTemplate.fieldIdentif'), trans: 'pricelistTemplate.fieldIdentif', sortable: true, class: 'text-center' },
			{ key: 'name', label: this.$t('pricelistTemplate.fieldName'), trans: 'pricelistTemplate.fieldName', sortable: true, class: 'text-left' },
			{ key: 'idTariffName', label: this.$t('pricelistTemplate.fieldTariffName'), trans: 'pricelistTemplate.fieldTariffName', sortable: true, class: 'text-center' },
			{ key: 'idItemTypeName', label: this.$t('pricelistTemplate.fieldItemTypeName'), trans: 'pricelistTemplate.fieldItemTypeName', sortable: true, class: 'text-center' },
			{ key: 'description', label: this.$t('pricelistTemplate.fieldDescription'), trans: 'pricelistTemplate.fieldDescription', sortable: true, visible: true, class: 'text-center' },

			{ key: 'identifier', label: this.$t('pricelistTemplate.fieldIdentifier'), trans: 'pricelistTemplate.fieldIdentifier', sortable: true, visible: true, class: 'text-center' },
			{ key: 'priceDay', label: this.$t('pricelistTemplate.fieldPriceDay'), trans: 'pricelistTemplate.fieldPriceDay', sortable: true, visible: true, class: 'text-center' },
			{ key: 'priceMonth', label: this.$t('pricelistTemplate.fieldPriceMonth'), trans: 'pricelistTemplate.fieldPriceMonth', sortable: true, visible: true, class: 'text-center' },
			{ key: 'amount', label: this.$t('pricelistTemplate.fieldAmount'), trans: 'pricelistTemplate.fieldAmount', sortable: true, visible: true, class: 'text-center' },
			{ key: 'amountFrom', label: this.$t('pricelistTemplate.fieldAmountFrom'), trans: 'pricelistTemplate.fieldAmountFrom', sortable: true, visible: true, class: 'text-center' },
			{ key: 'amountTo', label: this.$t('pricelistTemplate.fieldAmountTo'), trans: 'pricelistTemplate.fieldAmountTo', sortable: true, visible: true, class: 'text-center' },

			{ key: 'unit', label: this.$t('pricelistTemplate.fieldUnit'), trans: 'pricelistTemplate.fieldUnit', sortable: true, visible: true, class: 'text-center' },


			{ key: 'description', label: this.$t('pricelistTemplate.fieldDescription'), trans: 'pricelistTemplate.fieldDescription', sortable: true, visible: true, class: 'text-center' },

			{ key: 'actions', label: this.$t('pricelistTemplate.fieldAction'), trans: 'pricelistTemplate.fieldAction', class: 'text-right', thClass: 'lastColumnMichael' }
		]
	};

	protected setfilters(value: any) {
		if (value != null) {
			this.filters = value;
		}
		else {
			this.filters = [
				{
					key: 'idTariff', label: this.$t('pricelistTemplate.fieldTariffName'), trans: 'pricelistTemplate.fieldTariffName', selected: true, value: this.defaultEnum, default: this.defaultEnum, type: 'text', useOwnEnumsSend: true,
					useOwnEnumsSendArray: this.typeEnums, useEnum: true, refItem: 'idTariff', showAnyTime: true, lang: this.$store.state.currentLanguage
				},
				{ key: 'name', label: this.$t('pricelistTemplate.fieldName'), trans: 'pricelistTemplate.fieldName', selected: false, value: null, type: 'text' },
				{ key: 'description', label: this.$t('pricelistTemplate.fieldDescription'), trans: 'pricelistTemplate.fieldDescription', selected: false, value: null, type: 'text' },
			];
		}
	}
	//TODO
	loadDefault(idType: string) {
		if (Number(idType) == 0) {
			this.idType = this.defaultEnum;
		}
	}

	protected fetchData() {
		super.fetchData();
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		let pricelistTemplateFilter: PricelistTemplateFilter = new PricelistTemplateFilter(null);
		var allItems = this.pricelistTemplateService.getAllByFilter(pricelistTemplateFilter);

		allItems.then(response => {
			this.items = response.data;

			for (var i = 0; i < this.items.length; i++) {
				if (this.typeEnums.filter((c: any) => c.value == this.items[i].idTariff).length == 0) {
					this.typeEnums.push({ value: this.items[i].idTariff, text: this.items[i].idTariffName, description: this.items[i].idTariffName });
				}
			}
			this.typeEnums = this.typeEnums.sort((a, b) => a.text.localeCompare(b.text));

			if (Number(this.idType) > 0) {
				this.defaultEnum = this.idType;
			}
			else {
				this.defaultEnum = this.typeEnums[0].value;
			}
			this.setfilters(null);

		});

		return allItems;
	}

	//zat�m nepotrebujeme
	fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return this.fetchDataFromServer();
	}

	refreshItems(items: any[], refreshData: any[]) {
		return items;
	}


	protected prepareItems(items: any[]) {
	};
}